import React, {Component} from 'react';
import '../user/User.css';
import Uploader2 from "../../components/Uploader/Uploader2";
import {request} from "../../util/APIUtils";
import Alert from "react-s-alert";
import {deepCopyObject, showAxiosError, trimObject} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";


class UserGuide extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            fileInfo: {
                userGuidePath: "",
                userGuideFileName: "userGuideFile",
                userGuideFile: "",
                userGuideThumbFile: ""
            },
            fileData: "",
        };

        this.handleInfoChange = this.handleInfoChange.bind(this);
        this.handleLogout = this.handleLogout.bind(this);

    }

    componentDidMount() {
        this.getFileData("/opt/wildfly/images/_userguide.pdf");
    }

    getFileData(path) {
        let params = {
            url: API_BASE_URL + "/uye/member-image?filePath=" + path,
            method: 'get',
        }
        this.setState({loading: true});
        request(params).then((response) => {
            this.setState({fileData: response.data.base64File, loading: false});
        }).catch((error) => {
            this.setState({loading: false});
            showAxiosError(error);
        });
    }

    handleLogout() {
        this.props.handleLogout();
    }

    handleInfoChange(name, value) {
        let fileInfo = this.state.fileInfo;
        fileInfo[name] = value;
        this.setState({fileInfo});
    }

    saveFile = () => {
        if (this.state.fileInfo.userGuideFile !== "") {
            let fileInfo = deepCopyObject(this.state.fileInfo);
            fileInfo = trimObject(fileInfo);

            let message = 'Dosya yüklendi ve başarıyla kaydedildi.';
            let params = {
                url: API_BASE_URL + "/userGuide/",
                method: 'post',
                data: fileInfo,
            }
            this.setState({loading: true});
            request(params).then(() => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                this.getFileData("/opt/wildfly/images/_userguide.pdf");
                this.setState({loading: false});
            }).catch((error) => {
                this.setState({loading: false});
                showAxiosError(error);
            });
        } else {
            Alert.error(
                "Yüklemek için dosya seçmeniz gerekmektedir", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
        }

    }


    render() {
        return (
            <div className="col-md-12 satirBasi">
                <div className="card-body">
                    {this.props.currentUser.realm === 0 &&
                    <div className="FormRenk col-sm-10">
                        <div className="row">
                            <div className="col-sm-1"/>
                            <div className="col-sm-8 form-group">
                                <label style={{color: 'cornflowerblue', fontWeight: 'bold'}}>Portal
                                    Kullanım Kılavuzu'nu güncellemek için dosya (pdf) yükleyiniz </label>
                                <Uploader2 onInfoChange={this.handleInfoChange}
                                           fileName="userGuideFile"
                                           thumbFileName="userGuideThumbFile"
                                           filePathName="userGuidePath"
                                           pathPrefix="userGuide"
                                           memberTCKN={""}
                                           filePath={this.state.fileInfo.userGuidePath}
                                           file={this.state.fileInfo.userGuideFile}
                                           thumb={this.state.fileInfo.userGuideThumbFile}
                                           isDisabled={false}/>
                            </div>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    title="Dosyayı kaydet"
                                    style={{
                                        background: 'linear-gradient(#2b93cd, #0a66b7)',
                                        height: '40px',
                                        width: '155px',
                                        float: 'right',
                                        marginRight: '30px',
                                        color: 'white',
                                        borderRadius: '0.375em',
                                        alignSelf:"end",
                                    }}
                                    disabled={(this.state.fileInfo.userGuideFile === "")}
                                    rel="tooltip" className="TekBtn save"
                                    onClick={() => this.saveFile()}>
                                Dosya Yükle
                            </button>
                        </div>
                    </div>}
                    {this.state.fileData !== "" &&
                    <div className="FormRenk col-sm-10">
                        <h5 style={{textAlign: 'center', fontWeight: 'bold'}}>Portal Kullanım Kılavuzu</h5>
                        <iframe style={{top: 0, left: 0, width: "100%", height: "900px"}}
                                src={this.state.fileData}/>
                        {!this.state.fileData && "Yükleniyor..."}
                    </div>
                    }
                </div>
            </div>
        )
    }
}

export default UserGuide



// WEBPACK FOOTER //
// ./src/page/userGuide/UserGuide.js